// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as SettingsBDefault } from '../../../../../ui-v3/src/assets/icons/default/general/settings-b.svg?react';
import { ReactComponent as SettingsBSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/SETTINGS-B.svg?react';
import { createIcons } from '../../Icon';
const SettingsBIcon = /* @__PURE__ */ createIcons('SettingsB', {
    default: SettingsBDefault,
    solid: SettingsBSolid
});
SettingsBIcon.supportedTypes = [
    'default',
    'solid'
];
SettingsBIcon.category = 'general';
export default SettingsBIcon;
